(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zs-logo-with-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  let swiperInstance = null;

  function initSwiper() {
    const wrapper = document.querySelector('.zs-logo-text-wrapper');
    const inner = wrapper.querySelector('.zs-inner-wrapper');

    // Add swiper classes
    wrapper.classList.add('swiper');
    inner.classList.add('swiper-wrapper');
    inner.querySelectorAll('.zs-slide').forEach(slide => {
      slide.classList.add('swiper-slide');
    });

    swiperInstance = new Swiper('.zs-logo-text-wrapper', {
      slidesPerView: 2, // Show 2 slides at once on mobile for better visibility
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  }

  function destroySwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;

      // Remove swiper classes
      const wrapper = document.querySelector('.zs-logo-text-wrapper');
      const inner = wrapper.querySelector('.zs-inner-wrapper');
      wrapper.classList.remove('swiper');
      inner.classList.remove('swiper-wrapper');
      inner.querySelectorAll('.zs-slide').forEach(slide => {
        slide.classList.remove('swiper-slide');
      });
    }
  }

  function checkScreen() {
    if (window.innerWidth <= 768) {
      if (!swiperInstance) initSwiper();
    } else {
      destroySwiper();
    }
  }

  // Initial check
  checkScreen();

  // Re-check on resize
  window.addEventListener('resize', checkScreen);
});

  } catch(e) { console.error(e); }
})();
})();
